import requestHeaders from './request-headers'

const createRequestConfig = ({ headers = {} } = {}) => {

    return {
        headers: {
            ...requestHeaders,
            ...headers
        }
    }
}

export default createRequestConfig